import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, NavigationStart, RouterEvent } from '@angular/router';
import { IHilAvaialabilityConfig } from 'src/app/models/hil-availability';
import { filter } from 'rxjs/operators';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { BotRegistrationService } from 'src/app/services/core/bot-registration/bot-registration.service';
import { ToasterService } from 'src/app/services/shared/toaster/toaster.service';

@Component({
  selector: 'app-enablehiledit',
  templateUrl: './enablehiledit.component.html',
  styleUrls: ['./enablehiledit.component.scss']
})
export class EnablehileditComponent implements OnInit {
  botDetails: any;
  hilAvailabilityConfigForm: FormGroup;
  hilFromHour: FormControl;
  hilFromMin: FormControl;
  hilToHour: FormControl;
  hilToMin: FormControl;
  hilEnabled: FormControl;
  hilWeekendEnablement: FormControl;

  _routerSubscription: any;
  saveClicked: boolean = false;
  hasError: boolean = false;

  botHilAvailabilityConfigDetails: IHilAvaialabilityConfig;
  botHilAvailabilityConfigId: number=0;
  botConfigId: number;

  constructor(private router: Router,
    private dialogRef: MatDialogRef<EnablehileditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _botRegistrationService: BotRegistrationService,
    private _toaster: ToasterService) { }

  ngOnInit() {
    this.botDetails = JSON.parse(JSON.stringify(this.data));
    this.botConfigId= this.botDetails.botConfigId;

    this.hilEnabled = new FormControl('', Validators.required);
    this.hilFromHour = new FormControl('', Validators.required);
    this.hilFromMin = new FormControl('', Validators.required);
    this.hilToHour = new FormControl('', Validators.required);
    this.hilToMin = new FormControl('', Validators.required);
    this.hilWeekendEnablement = new FormControl('', Validators.required);

    this.hilAvailabilityConfigForm = new FormGroup({
      hilEnabled: this.hilEnabled,
      hilFromHour: this.hilFromHour,
      hilFromMin: this.hilFromMin,
      hilToHour: this.hilToHour,
      hilToMin: this.hilToMin,
      hilWeekendEnablement: this.hilWeekendEnablement
    });

    this.hilAvailabilityConfigForm.controls['hilFromHour'].setValue('00', { onlySelf: true });
    this.hilAvailabilityConfigForm.controls['hilFromMin'].setValue('00', { onlySelf: true });
    this.hilAvailabilityConfigForm.controls['hilToHour'].setValue('00', { onlySelf: true });
    this.hilAvailabilityConfigForm.controls['hilToMin'].setValue('00', { onlySelf: true }); 

    this._routerSubscription = this.router.events
      .pipe(
        filter((event: RouterEvent) => event instanceof NavigationStart),
        filter(() => !!this.dialogRef)
      )
      .subscribe(() => {
        this.dialogRef.close();
      });
    
      this._botRegistrationService.getBotHilAavaialabilityConfig(this.botDetails.botConfigId)
      .subscribe(
        res => {
          if (res == null) {
            this.reset();
            return;
          }
          this.hilEnabled.setValue(res.enabled);
          this.hilFromHour.setValue(res.fromTime.split(':')[0]);
          this.hilFromMin.setValue(res.fromTime.split(':')[1]);
          this.hilToHour.setValue(res.toTime.split(':')[0]);
          this.hilToMin.setValue(res.toTime.split(':')[1]);
          this.hilWeekendEnablement.setValue(res.excludeWeekends);
          this.botConfigId = res.botConfigId;
          this.botHilAvailabilityConfigId = res.id;
        },
        (error) => {
          this.hasError = true;
          console.log(error);
        }
      );
  }

  reset() {
    this.hilEnabled.setValue(false);
    this.hilFromHour.setValue('00');
    this.hilFromMin.setValue('00');
    this.hilToHour.setValue('00');
    this.hilToMin.setValue('00');
    this.hilWeekendEnablement.setValue(true);
    this.botHilAvailabilityConfigId = 0;
  }

  updateHilStatus(formValues) {
    this.saveClicked = true;
    this.hasError = false;

    this.botHilAvailabilityConfigDetails = {
      botConfigId: this.botConfigId,
      fromTime: formValues.hilFromHour + ':' + formValues.hilFromMin,
      toTime: formValues.hilToHour + ':' + formValues.hilToMin,
      enabled: formValues.hilEnabled === true,
      excludeWeekends: formValues.hilWeekendEnablement === true,
      id: this.botHilAvailabilityConfigId == undefined ? 0 : this.botHilAvailabilityConfigId,
    }

    this._botRegistrationService.addUpdateBotHilAavaialability(this.botHilAvailabilityConfigDetails)
      .subscribe(
        res => {
          this.dialogRef.close('CONFIRM');
          this._toaster.success("Hil status updated successfully!!");
          this.botHilAvailabilityConfigId = res;
        },
        (error) => {
          this.hasError = true;
          console.log(error);
        }
      );
  }

  onCancel() {
    this.dialogRef.close('CANCEL');
  }

  onClose() {
    this.dialogRef.close('CLOSE');
  }
}
